module.exports = __webpack_public_path__ + "img/logo-outlook-duplicate-remover-m.5496994.png";